import React from "react";
import ApplicationMessages from "../../features/applicationmessages";

const ApplicationsMessagesPage = () => <ApplicationMessages />

export default ApplicationsMessagesPage;